module.exports = __webpack_public_path__ + "img/ic_check_blue.d388cb0f.svg";